import { render, staticRenderFns } from "./DropdownBasic.vue?vue&type=template&id=03a27554&"
import script from "./DropdownBasic.vue?vue&type=script&lang=js&"
export * from "./DropdownBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports